export enum AppAutoUpdatePolicy {
  APP_AUTO_UPDATE_POLICY_UNSPECIFIED = 'App auto update policy unspecified',
  CHOICE_TO_THE_USER = 'Choice to the user',
  NEVER = 'Never',
  WIFI_ONLY = 'Wifi only',
  ALWAYS = 'Always',
}
